import { InjectionToken } from '@angular/core';

export const CAPACITY_MANAGEMENT_QUICK_FILTERS_STORE_NAME = new InjectionToken<string>('quick-filters-store-name');
export const CAPACITY_MANAGEMENT_STORE_NAME = new InjectionToken<string>('capacity-management-store-name');
